import { Vue } from '../vue';
import { PROP_TYPE_STRING } from '../constants/props';
import { makeProp, makePropsConfigurable } from '../utils/props'; // --- Props ---

export var props = makePropsConfigurable({
  size: makeProp(PROP_TYPE_STRING)
}, 'formControls'); // --- Mixin ---
// @vue/component

export var formSizeMixin = Vue.extend({
  props: props,
  computed: {
    sizeFormClass: function sizeFormClass() {
      return [this.size ? "form-control-".concat(this.size) : null];
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/form-size.js
// module id = 52
// module chunks = 0